module.exports = __webpack_public_path__ + "static/media/blueTriangle.cffa7fc8.png";